import { BadgeColors } from '@src/app/components';

import { ConnectionState } from '../types';

export const ConnectionStateColor = {
  [ConnectionState.Connected]: BadgeColors.Green,
  [ConnectionState.Disconnected]: BadgeColors.Red,
  [ConnectionState.Connecting]: BadgeColors.Yellow,
  [ConnectionState.Disconnecting]: BadgeColors.Yellow,
  [ConnectionState.Reconnecting]: BadgeColors.Yellow,
};
